import { SYNC_CONTENTFUL_DATA } from '../../constants';
export function syncContentData(payload) {
    return {
        type: SYNC_CONTENTFUL_DATA,
        payload,
    };
}
